import { useDispatch, useSelector } from "react-redux";

import { Box } from "@mui/material";

import { ActionButton } from "components/ActionButton";
import { HoverHelp } from "components/utility/HoverHelp";

import { i18n } from "services/i18nService";
import { clearItemsCache } from "services/sosInventoryService/sosApi";

import { openAlert } from "globalState/alertSlice";
import {
  loadingIndicatorOn,
  loadingIndicatorOff,
} from "globalState/loadingSlice";

export function ClearItemCache() {
  const dispatch = useDispatch();
  const isLoading = useSelector((state) => state.loading.list);

  async function handleClearItemsCache() {
    dispatch(loadingIndicatorOn());
    const { success } = await clearItemsCache();
    if (success) {
      const message = i18n("dataUtilities.ClearCacheUpdateStarted");
      dispatch(openAlert({ type: "success", message }));
    }
    dispatch(loadingIndicatorOff());
  }

  return (
    <Box sx={{ pl: "0.5rem", display: "flex", alignItems: "center", gap: 1 }}>
      <ActionButton
        sx={{ width: "8rem" }}
        onClick={handleClearItemsCache}
        disabled={isLoading}
      >
        {i18n("dataUtilities.ClearItemCache")}
      </ActionButton>
      <HoverHelp title={i18n("dataUtilities.ClearItemCache.hoverHelp")} />
    </Box>
  );
}
